const type = 'UPDATING_ACCOUNT_PARAMETER';

const updatingAccountParameter = (payload) => ({
  type,
  payload,
});

export { type };
export default updatingAccountParameter;
